import { render } from "./BillList.vue?vue&type=template&id=2ad43677&ts=true"
import script from "./BillList.vue?vue&type=script&lang=ts"
export * from "./BillList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__